import { lazy } from "react";
import Route from "../../enums/route";
const LoginPage = lazy(() => import("../../components/pages/login/Login"));
const VeoliaLoginPage = lazy(() => import("../../components/pages/login/VeoliaLogin"));
export const unauthenticatedRoutes = [
    {
        path: Route.Login,
        component: LoginPage
    },
    {
        path: Route.VeoliaPrefix,
        component: VeoliaLoginPage
    }
];
